import React from 'react';
import ClockIcon from '@assets/icons/clock.svg';
import BellIcon from '@assets/icons/notifications/bell.svg';
import RefreshArrowsIcon from '@assets/icons/refresh-arrows.svg';
import StarsIcon from '@assets/icons/stars.svg';
import TagIcon from '@assets/icons/tag.svg';
import { BodyXsXsMedium } from '@constants/text.ts';
import { useLingui } from '@lingui/react/macro';
import { getLearningStatus } from '@routes/sidebar/___shared___/utils.ts';
import type { LearningResponse } from '@routes/sidebar/learning/api/learning.api.ts';
import {
    CardPillIcon,
    CardPillLabel,
    CardPillLabelsWrapper,
    CardPills,
    PillDueSoon,
    PillOverdue,
    PillRefresher,
    PillsStatus,
    PillUpdated,
    Spacer,
} from '@routes/sidebar/learning/ui/learning-tab/card-pill-labels/styled.tsx';

interface Props {
    learning: LearningResponse;
    serverTime: Date;
}

const CardPillLabels: React.FC<Props> = ({ learning, serverTime }) => {
    const { t } = useLingui();
    const { isOverdue, isRefresher, isUpdated, isDueSoon } = getLearningStatus(learning, serverTime);

    return (
        <CardPillLabelsWrapper>
            <CardPills>
                <CardPillLabel>
                    <CardPillIcon>
                        <TagIcon />
                    </CardPillIcon>
                    <BodyXsXsMedium>{learning.learningDetails.category.focus}</BodyXsXsMedium>
                </CardPillLabel>
                <Spacer />
                <PillsStatus>
                    <>
                        {!!isOverdue && (
                            <PillOverdue>
                                <ClockIcon />
                                <BodyXsXsMedium>{t`Overdue`}</BodyXsXsMedium>
                            </PillOverdue>
                        )}
                        {!!isDueSoon && (
                            <PillDueSoon>
                                <BellIcon />
                                <BodyXsXsMedium>{t`Due soon`}</BodyXsXsMedium>
                            </PillDueSoon>
                        )}
                        {!!isRefresher && (
                            <PillRefresher>
                                <RefreshArrowsIcon />
                                <BodyXsXsMedium>{t`Refresher`}</BodyXsXsMedium>
                            </PillRefresher>
                        )}
                        {!!isUpdated && (
                            <PillUpdated>
                                <StarsIcon />
                                <BodyXsXsMedium>{t`Updated`}</BodyXsXsMedium>
                            </PillUpdated>
                        )}
                    </>
                </PillsStatus>
            </CardPills>
        </CardPillLabelsWrapper>
    );
};

export default CardPillLabels;
